// extracted by mini-css-extract-plugin
export default {"firstPartText":"YxGTo","secondPartText":"nLjgK"};